import React from "react";
import { useSelector } from "react-redux";
import MapWithMarkers from "./MapWithMarkers";

const DetailedStyledMapWithAnInfoBox = () => {
  const { selectedResellerItem } = useSelector((state) => state.googleMap);
  const markers = [
    {
      id: "selected",
      position: {
        lat: parseFloat(selectedResellerItem.latitude),
        lng: parseFloat(selectedResellerItem.longitude),
      },
      info: selectedResellerItem,
    },
  ];

  return (
    <MapWithMarkers
      center={markers[0].position}
      zoom={10}
      markers={markers}
      openMarkerId="selected"
      onMarkerClick={() => { }}
      onInfoWindowClose={() => { }}
    />
  );
};

export default DetailedStyledMapWithAnInfoBox;
